<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapActions, mapGetters } from "vuex";

/**
 * Advanced table component
 */
export default {
  page: {
    title: "Budget",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      title: "Financial Years",
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Budget",
          active: true,
        },
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: "age",
      sortDesc: false,
      fields: [
        {
          key: "index",
          label: "No",
          sortable: true,
        },
        {
          key: "name",
          label: "Full Name",
          sortable: true,
        },
        {
          key: "start",
          label: "Start",
          sortable: true,
        },
        {
          key: "end",
          label: "End",
          sortable: true,
        },
        {
          key: "user",
          label: "Added By",
          sortable: true,
        },
        {
          key: "date",
          label: "Added On",
          sortable: true,
        },
        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      data: {
        name: "",
        start: "",
        end: "",
      },
      deletedata: {
        name: "",
        id: "",
      },
      editdata: {
        name: "",
        start: "",
        end: "",
        id: "",
      },
      existingYear: [],
      nameError: "",
      startError: "",
      endError: "",
      modal: "",
    };
  },
  computed: {
    ...mapGetters("budget", ["FinancialYears", "SaveStatus"]),
    ...mapGetters("auth", ["getCurrentUser"]),
    /**
     * Total no. of records
     */
    rows() {
      return this.FinancialYears ? this.FinancialYears.length : 1;
    },
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.FinancialYears ? this.FinancialYears.length : 1;
  },
  methods: {
    ...mapActions({
      FetchFinancialYear: "budget/fetchFyears",
      AddFinancialYear: "budget/addFinancialYear",
      EditFinancialYear: "budget/editFinancialYear",
      DeleteFinancialYear: "budget/deleteFinancialYear",
    }),

    /**
     * Search the table data with search input
     */
    onFiltered() {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = this.FinancialYears ? this.FinancialYears.length : 1;
      this.currentPage = 1;
    },

    resetError() {
      this.nameError = "";
      this.startError = "";
      this.endError = "";
    },

    resetAddModal() {
      this.data.name = "";
      this.data.start = "";
      this.data.end = "";
      this.resetError();
    },
    resetEditModal() {
      this.editdata.name = "";
      this.editdata.start = "";
      this.editdata.end = "";
      this.resetError();
    },
    resetDeleteModal() {
      this.deletedata.name = "";
      this.deletedata.id = "";
    },

    checkName() {
      if (this.data.name != "") {
        this.existingYear = this.FinancialYears.filter((stream) => {
          return stream.name.toUpperCase() == this.data.name.toUpperCase();
        });
        if (this.existingYear.length) {
          this.nameError = this.data.name + " exists already";
        } else {
          this.nameError = "";
        }
      } else {
        this.existingYear = [];
      }
    },
    addFinancialYear(modal) {
      if (this.data.name == "") {
        this.nameError = "Financial Year Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.start == "") {
        this.startError = "Financial Year Start field can't be empty";
        return;
      } else {
        this.startError = "";
      }
      if (this.existingYear.length) {
        this.nameError = this.data.name + " exists already Please";
        return;
      } else {
        this.nameError = "";
      }
      if (this.data.end == "") {
        this.endError = "Financial Year End field can't be empty";
        return;
      } else {
        this.endError = "";
      }
      this.modal = modal;
      this.AddFinancialYear(this.data);
      this.resetError();
      this.resetAddModal();
      this.closeModal(this.modal);
    },
    showEditModal(values) {
      this.editdata.id = values.item.id;
      this.editdata.name = values.item.name;
      this.editdata.start = values.item.start;
      this.editdata.end = values.item.end;
    },
    showDeleteModal(values) {
      this.deletedata.id = values.item.id;
      this.deletedata.name = values.item.name;
    },
    deleteFinancialYear(modal) {
      this.modal = modal;
      this.DeleteFinancialYear(this.deletedata);
      this.closeModal(modal);
    },
    editFinancialYear(modal) {
      if (this.editdata.name == "") {
        this.nameError = "Financial Year Name field can't be empty";
        return;
      } else {
        this.nameError = "";
      }
      if (this.editdata.start == "") {
        this.startError = "Financial Year start field can't be empty";
        return;
      } else {
        this.startError = "";
      }
      if (this.editdata.end == "") {
        this.endError = "Financial Year end field can't be empty";
        return;
      } else {
        this.endError = "";
      }
      this.modal = modal;
      this.EditFinancialYear(this.editdata);
      this.resetError();
      this.closeModal(this.modal);
    },

    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchFinancialYear();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div
      class="row"
      v-if="
        getCurrentUser.permissions.find((item) =>
          item.permission.includes('view_financial_year')
        )
      "
    >
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-9">
                <h3 class="card-title text-primary">
                  List of All Financial Years
                </h3>
              </div>
              <div class="col-3">
                <button
                  v-b-modal.add-stream-modal
                  class="btn btn-primary float-end"
                  v-if="
                    getCurrentUser.permissions.find((item) =>
                      item.permission.includes('add_financial_year')
                    )
                  "
                >
                  <i class="fa fa-plus"></i> Add New
                </button>
              </div>
            </div>
            <div class="row mt-2">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="FinancialYears ? FinancialYears : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(actions)="data">
                  <b-button-group>
                    <b-button
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_financial_year')
                        )
                      "
                      size="sm"
                      variant="primary"
                      v-b-modal.edit-fyear-modal
                      @click="showEditModal(data)"
                      ><i class="fa fa-edit"></i> Edit</b-button
                    >
                    <b-button
                      v-if="
                        getCurrentUser.permissions.find((item) =>
                          item.permission.includes('edit_financial_year')
                        )
                      "
                      size="sm"
                      variant="danger"
                      v-b-modal.delete-fyear-modal
                      @click="showDeleteModal(data)"
                      ><i class="fa fa-trash"></i> Delete</b-button
                    >
                  </b-button-group>
                </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div
                  class="dataTables_paginate paging_simple_numbers float-end"
                >
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- modal starts -->
      <b-modal id="add-stream-modal" hide-footer @hidden="resetAddModal()">
        <template #modal-title> Add New Financial Year </template>
        <div class="form-group mb-3">
          <label>Name</label>
          <div class="input-group">
            <input
              type="text"
              placeholder="Financial Year Name"
              class="form-control"
              @input="resetError()"
              v-model="data.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Start Date</label>
          <div class="input-group">
            <input
              type="date"
              placeholder="Financial Year Start Date"
              class="form-control"
              @input="resetError()"
              v-model="data.start"
            />
          </div>
          <div class="text-danger" v-if="startError">
            <em>{{ startError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>End Date</label>
          <div class="input-group">
            <input
              type="date"
              placeholder="Financial Year End Date"
              class="form-control"
              @input="resetError()"
              v-model="data.end"
            />
          </div>
          <div class="text-danger" v-if="endError">
            <em>{{ endError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('add-stream-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="addFinancialYear('add-stream-modal')"
          >
            <i class="fa fa-check"></i>
            Submit
            <b-spinner
              v-if="SaveStatus"
              variant="light"
              small
              label="Spinning"
            ></b-spinner>
          </button>
        </div>
      </b-modal>
      <!-- modal ends -->
      <!-- edit modal starts -->
      <b-modal id="edit-fyear-modal" hide-footer @hidden="resetEditModal()">
        <template #modal-title>
          Edit Financial Year {{ editdata.name }}</template
        >
        <div class="form-group mb-3">
          <label>Financial Year Name</label>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              @input="resetError()"
              v-model="editdata.name"
            />
          </div>
          <div class="text-danger" v-if="nameError">
            <em>{{ nameError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>Start Date</label>
          <div class="input-group">
            <input
              type="date"
              placeholder="Financial Year Start Date"
              class="form-control"
              @input="resetError()"
              v-model="editdata.start"
            />
          </div>
          <div class="text-danger" v-if="startError">
            <em>{{ startError }}</em>
          </div>
        </div>
        <div class="form-group mb-3">
          <label>End Date</label>
          <div class="input-group">
            <input
              type="date"
              placeholder="Financial Year End Date"
              class="form-control"
              @input="resetError()"
              v-model="editdata.end"
            />
          </div>
          <div class="text-danger" v-if="endError">
            <em>{{ endError }}</em>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-danger"
            data-dismiss="modal"
            @click="closeModal('edit-fyear-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-primary"
            @click="editFinancialYear('edit-fyear-modal')"
          >
            <i class="fa fa-check"></i>
            Save Changes</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Saving"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->

      <!-- modal delete fyear starts -->
      <b-modal id="delete-fyear-modal" hide-footer @hidden="resetDeleteModal">
        <template #modal-title>
          <h4 class="text-danger">
            Delete Financial Year {{ deletedata.name }}
          </h4></template
        >
        <div class="form-group mb-3">
          <div class="input-group">
            <h5>
              Do you want to delete Financial Year {{ deletedata.name }}? Click
              Proceed Button to delete.
            </h5>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
            @click="closeModal('delete-fyear-modal')"
          >
            <i class="fa fa-times"></i> Close
          </button>
          <button
            type="button"
            class="btn btn-danger"
            @click="deleteFinancialYear('delete-fyear-modal')"
          >
            <i class="fa fa-trash"></i> Confirm</button
          ><b-spinner
            v-if="SaveStatus"
            variant="primary"
            small
            label="Deleting"
          ></b-spinner>
        </div>
      </b-modal>
      <!-- modal ends -->
    </div>
    <div class="row d-flex" v-else>
      <div class="col-md-8 mx-auto">
        <div class="jumbotron py-5 text-center">
          <strong class="display-6 text-danger">
            Access Denied <i class="fa fa-exclamation" aria-hidden="true"></i
          ></strong>
          <p class="lead text-muted py-4">
            Request For Permission From Administrator
          </p>
        </div>
      </div>
    </div>
  </Layout>
</template>
